import { render, staticRenderFns } from "./MsgElementSessionAskPatient.vue?vue&type=template&id=d058187a&scoped=true"
import script from "./MsgElementSessionAskPatient.vue?vue&type=script&lang=js"
export * from "./MsgElementSessionAskPatient.vue?vue&type=script&lang=js"
import style0 from "./MsgElementSessionAskPatient.vue?vue&type=style&index=0&id=d058187a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d058187a",
  null
  
)

export default component.exports